/* Land Media theme — header scroll states, mobile menu, active nav link, account helpers. */
(function () {
  function initHeader() {
    var header = document.querySelector('[data-lm-header]');
    if (!header || header.__lmInit) return;
    header.__lmInit = true;

    var toggle = header.querySelector('[data-lm-menu-toggle]');
    var menu = header.querySelector('[data-lm-menu]');
    var lastY = window.scrollY;
    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        // While the menu holds the page still, body is position:fixed and scrollY reads 0: ignore that.
        if (document.body.style.position === 'fixed') return;
        var y = window.scrollY;
        header.classList.toggle('is-scrolled', y > 40);
        // Hide when scrolling down past the fold, show again on any scroll up.
        if (y > 400 && y > lastY + 4) header.classList.add('is-hidden');
        else if (y < lastY - 4 || y < 400) header.classList.remove('is-hidden');
        // Sticky bars (e.g. the services catalogue) move up into the space the header leaves.
        document.documentElement.classList.toggle('lm-header-hidden', header.classList.contains('is-hidden'));
        lastY = y;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var html = document.documentElement;
    var body = document.body;
    var lockedY = 0;

    // The menu circle grows out of the burger; its top padding clears the header bar.
    function placeMenu() {
      if (!menu || !toggle) return;
      var r = toggle.getBoundingClientRect();
      menu.style.setProperty('--lm-mx', Math.round(r.left + r.width / 2) + 'px');
      menu.style.setProperty('--lm-my', Math.round(r.top + r.height / 2) + 'px');
      var inner = header.querySelector('.lm-header__inner');
      if (inner) header.style.setProperty('--lm-header-h', Math.round(inner.getBoundingClientRect().bottom) + 'px');
    }
    // Scroll lock that also holds on iOS Safari (overflow:hidden on <html> alone does not).
    function lockScroll(lock) {
      if (lock) {
        lockedY = window.scrollY;
        body.style.position = 'fixed';
        body.style.top = -lockedY + 'px';
        body.style.left = '0';
        body.style.right = '0';
        body.style.width = '100%';
      } else if (body.style.position === 'fixed') {
        body.style.position = body.style.top = body.style.left = body.style.right = body.style.width = '';
        var prev = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';
        window.scrollTo(0, lockedY);
        html.style.scrollBehavior = prev;
        lastY = lockedY;
      }
    }
    function focusables() {
      var list = [toggle].concat(Array.prototype.slice.call(menu.querySelectorAll('a[href], button:not([disabled])')));
      return list.filter(function (el) { return el && el.offsetParent !== null; });
    }
    function setOpen(open) {
      if (header.classList.contains('is-open') === open) return;
      if (open) placeMenu();
      header.classList.toggle('is-open', open);
      html.classList.toggle('lm-menu-open', open);
      lockScroll(open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (menu) {
        if (open) menu.removeAttribute('inert'); else menu.setAttribute('inert', '');
        if (open) {
          var first = menu.querySelector('a[href]');
          if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
        }
      }
    }
    if (menu) menu.setAttribute('inert', '');
    if (toggle) toggle.addEventListener('click', function () { setOpen(!header.classList.contains('is-open')); });
    if (menu) menu.addEventListener('click', function (e) { if (e.target.closest('a')) setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (!header.classList.contains('is-open')) return;
      if (e.key === 'Escape') { setOpen(false); if (toggle) toggle.focus(); return; }
      // Focus trap: Tab cycles between the close button and the menu links.
      if (e.key === 'Tab' && menu) {
        var f = focusables();
        if (!f.length) return;
        var i = f.indexOf(document.activeElement);
        if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && (i === f.length - 1 || i === -1)) { e.preventDefault(); f[0].focus(); }
      }
    });
    window.addEventListener('resize', function () { if (window.innerWidth > 989) setOpen(false); else if (header.classList.contains('is-open')) placeMenu(); });

    // Highlight the nav link for the homepage section in view.
    var links = Array.prototype.slice.call(header.querySelectorAll('[data-lm-navlink]'));
    var targets = links.map(function (a) {
      var hash = (a.getAttribute('href') || '').split('#')[1];
      return hash ? document.getElementById(hash) : null;
    });
    if ('IntersectionObserver' in window && targets.some(Boolean)) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var i = targets.indexOf(entry.target);
          if (i < 0) return;
          if (entry.isIntersecting) {
            links.forEach(function (l) { l.classList.remove('is-active'); });
            links[i].classList.add('is-active');
          } else {
            links[i].classList.remove('is-active');
          }
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      targets.forEach(function (t) { if (t) io.observe(t); });
    }
  }

  function initAccount() {
    document.querySelectorAll('[data-lm-toggle-recover]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var box = document.getElementById('lm-recover');
        if (!box) return;
        e.preventDefault();
        box.classList.toggle('is-open');
        var input = box.querySelector('input');
        if (input && box.classList.contains('is-open')) input.focus();
      });
    });
  }

  /* Intro preloader: counter eases to 90% while loading and finishes once the page is ready
     (DOM parsed + brand font loaded), min 1.2s, max 2.4s. It doesn't wait for window.load, which
     also waits for Shopify's analytics scripts and kept slow phones on the loader. */
  function initLoader() {
    var html = document.documentElement;
    var loader = document.querySelector('[data-lm-loader]');
    if (!loader || !html.classList.contains('lm-intro')) return;
    var countEl = loader.querySelector('[data-lm-loader-count]');
    var barEl = loader.querySelector('[data-lm-loader-bar]');
    var start = performance.now(), loaded = false, shown = 0, finished = false;
    function ready() {
      var fonts = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
      fonts.then(function () { loaded = true; }, function () { loaded = true; });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();

    function finish() {
      if (finished) return;
      finished = true;
      html.classList.add('lm-intro-done');
      try { sessionStorage.setItem('lmIntro', '1'); } catch (e) {}
      setTimeout(function () {
        html.classList.remove('lm-intro', 'lm-intro-done');
        loader.remove();
      }, 1400);
    }
    (function tick(now) {
      var t = now - start;
      // Minimum 1.2s so the logo animation lands (its wipe takes 1.3s); force-finish at 2.4s.
      var target = loaded && t > 1200 ? 100 : Math.min(90, (t / 1200) * 90);
      if (t > 2400) target = 100;
      shown += (target - shown) * 0.12;
      if (target === 100 && shown > 99.4) shown = 100;
      countEl.textContent = Math.round(shown);
      barEl.style.transform = 'scaleX(' + (shown / 100).toFixed(3) + ')';
      if (shown >= 100) { setTimeout(finish, 180); return; }
      requestAnimationFrame(tick);
    })(start);
  }

  initLoader();
  function boot() { initHeader(); initAccount(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { initHeader(); });
})();
